import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";

const LoadingSpinner = () => {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100 bg-body-primary"
    >
      <Spinner animation="border" role="status" variant="info">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </Container>
  );
};

export default LoadingSpinner;
